import { getPhone } from '/b2b/authentication/state/Auth.selectors';
import { update } from './SetupPhone.commands';

export const mapStateToProps = state => {
    return {
        phone: getPhone(state),
    };
};

export const mapDispatchToProps = { onSubmit: update };
